/* eslint-disable react/prop-types */
/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prettier/prettier */
import React, { useRef, useState } from 'react';
import Page from 'components/custom/template/Page';
import useManagePageLoading from 'hooks/custom/useManagePageLoading';
import apiEndpoints from 'constants/apiEndpoints';
import postData from 'services/postData';
import { useAlert } from 'providers/AlertModalProvider';
import TruckerPaymentCheckListColumn from './TruckerPaymentCheckListColumn';
import useShowModal from 'hooks/custom/useShowModal';
import CreateSettlementModal from 'pages/vendors/trucker/trucker-detail/trucker-detail-tab/payment-tab-items/PendingPayment/CreateSettlementModal';
import fetchData from 'services/fetchData';


const TruckerPaymentCheckList = () => {
  const [pageLoading, loadingMessage, handleLoading] = useManagePageLoading();

  const { showAlert } = useAlert();
  const refreshDataRef = useRef(null);

  const handleRefresh = () => {
    if (refreshDataRef.current) {
      refreshDataRef.current();
    }
  };
  const handleRefreshDataRegister = refreshData => {
    refreshDataRef.current = refreshData;
  };
  const createSettlement = useShowModal();

  const handleCheckDetail = async (data, viewOnly) => {
    handleLoading(true, 'Fetching Settlement Data');
    const getSettlementData = await fetchData(
      apiEndpoints.trucker.getSettlementDataById(data.settlement_id)
    );

    if (getSettlementData.status) {
      handleLoading(false, '');
      const settlementData = {
        trucker_id: getSettlementData.data.trucker_id,
        tds_percent: getSettlementData.data.tds_percent,
        challans: getSettlementData.data.challans,
        totalChallanAmount: getSettlementData.data.final_total_amount,
        final_amount: getSettlementData.data.final_total_amount,
        totalTdsCharges: getSettlementData.data.total_tds_charges,
        settel_id: data.settlement_id,
        created_by_name: getSettlementData.data.created_by_name,
        settelment_no: getSettlementData.data.settelment_no,
        settlement_date: getSettlementData.data.settelment_date,
        settlement_status: getSettlementData.data.status,
        viewOnly:viewOnly,
        truckerInformation: {
          truckerName: getSettlementData.data.trucker_name,
          contactNo: getSettlementData.data.trucker_phone,
          panNo: getSettlementData.data.pan_no,
          bankName: getSettlementData.data.trucker_bank_name,
          bankAccountNo: getSettlementData.data.trucker_account_number,
          ifscCode: getSettlementData.data.trucker_bank_ifsc
        }
      };
      createSettlement.handleOpenModal(settlementData);
    } else {
      handleLoading(false, '');
      showAlert({
        variant: 'danger',
        message: 'Failed to fetch settlement data'
      });
    }
  };
  const handleCheckSettlement = async data => {
    console.log('🚀 ~ 111handleApproveSettlement ~ data:', data);
    const postFormData = {
      settel_id: data.settel_id,
      status: 'First_Approved'
    };
    const request = await postData(
      postFormData,
      apiEndpoints.trucker.updateSettlementStatus
    );

    if (request.status) {
      showAlert({
        variant: 'info',
        message: `Settlement has been successfully Approved.`
      });
      handleRefresh();
      createSettlement.handleCloseModal();
    } else {
      showAlert({
        variant: 'danger',
        message: `Failed to Approve the settlement.`
      });
    }
  };
  const handleReject = async data => {
    const postFormData = {
      settel_id: data.settel_id,
      status: 'First_Rejected'
    };
    const request = await postData(
      postFormData,
      apiEndpoints.trucker.updateSettlementStatus
    );
    if (request.status) {
      showAlert({
        variant: 'info',
        message: `Settlement has been successfully Rejected.`
      });
      handleRefresh();
      createSettlement.handleCloseModal();
    }
  };
  return (
    <>
      <Page
        title={'Checking List'}
        tableColumn={{
          column: TruckerPaymentCheckListColumn(
            handleCheckDetail,
            handleLoading
          )
        }}
        urlEndPoint={apiEndpoints.trucker.getAllSettlementList}
        onRegisterRefresh={handleRefreshDataRegister}
        exportName="checking list"
        backdrop={{ message: loadingMessage, loading: pageLoading }}
        dataWithDateRange={false}
        dataFormatter={data =>
          data.filter(
            item =>
              item.status === 'Pending' || item.status === 'First_Rejected'
          )
        }
      >
        {createSettlement.isOpen && (
          <CreateSettlementModal
            show={createSettlement.isOpen}
            handleClose={createSettlement.handleCloseModal}
            data={createSettlement.modalData}
            refreshData={handleRefresh}
            handleLoading={handleLoading}
            modalType="checking"
            handleReject={handleReject}
            handleApproval={handleCheckSettlement}
          />
        )}
      </Page>
    </>
  );
};

export default TruckerPaymentCheckList;
